import qz from "qz-tray";
import { http } from "@/configurations/axios";

const QZ_ERROR_MESSAGE =
  "Não foi possível conectar ao QZ Tray. Verifique se o QZ Tray está instalado e aberto neste computador.";

let securitySetupPromise = null;

// Configura a assinatura digital das requisicoes do QZ Tray. Sem isso o QZ trata
// cada impressao como "anonymous/untrusted" e nao permite memorizar o "Allow"
// (so o "Block"). O backend fornece o certificado publico e assina cada
// requisicao com a chave privada (SHA-512 + RSA, assinatura em base64).
async function setupSecurity() {
  let certificate = null;

  try {
    const { data } = await http.get("/restaurante/qz/certificate");

    if (data && data.enabled && data.certificate) {
      certificate = data.certificate;
    }
  } catch (error) {
    certificate = null;
  }

  if (!certificate) {
    // QZ Tray sem certificado configurado no backend: segue sem assinatura
    // (o QZ exibira o aviso de site nao confiavel).
    return;
  }

  qz.security.setSignatureAlgorithm("SHA512");

  qz.security.setCertificatePromise((resolve) => {
    resolve(certificate);
  });

  qz.security.setSignaturePromise((toSign) => {
    return (resolve, reject) => {
      http
        .post("/restaurante/qz/sign", { request: toSign })
        .then((response) => {
          const signature =
            response && response.data && response.data.signature;

          if (signature) {
            resolve(signature);
          } else {
            reject(new Error("Assinatura do QZ Tray vazia."));
          }
        })
        .catch((error) => reject(error));
    };
  });
}

async function connect() {
  if (qz.websocket.isActive()) {
    return;
  }

  if (!securitySetupPromise) {
    securitySetupPromise = setupSecurity().catch(() => {
      securitySetupPromise = null;
    });
  }

  await securitySetupPromise;

  try {
    await qz.websocket.connect();
  } catch (error) {
    throw new Error(QZ_ERROR_MESSAGE);
  }
}

function normalizeRawText(conteudo) {
  const texto = String(conteudo || "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n")
    .replace(/\n/g, "\r\n")
    .trimEnd();

  return `${texto}\r\n\r\n\r\n\r\n`;
}

export async function listarImpressorasQz() {
  await connect();
  const printers = await qz.printers.find();

  if (Array.isArray(printers)) {
    return printers.filter(Boolean).sort();
  }

  return printers ? [printers] : [];
}

export async function imprimirTextoQz(impressora, conteudo) {
  if (!impressora) {
    throw new Error("Informe a impressora para imprimir o pedido.");
  }

  await connect();
  const config = qz.configs.create(impressora);

  return qz.print(config, [
    {
      type: "raw",
      format: "command",
      flavor: "plain",
      data: normalizeRawText(conteudo),
    },
  ]);
}

export async function imprimirTicketsProducao(tickets = []) {
  const validTickets = tickets.filter(
    (ticket) => ticket && ticket.impressora && ticket.conteudo
  );

  for (const ticket of validTickets) {
    await imprimirTextoQz(ticket.impressora, ticket.conteudo);
  }
}

export function ticketTesteProducao(destino) {
  const titulos = {
    bar: "BAR",
    checkout: "PEDIDO/CHECKOUT",
    comprovante: "COMPROVANTE",
    cozinha: "COZINHA",
  };
  const titulo = titulos[destino] || "RESTAURANTE";

  return [
    "================================",
    `TESTE ${titulo}`,
    "================================",
    "Mesa: Teste",
    "Comanda: Teste",
    "Horário: teste",
    "--------------------------------",
    "Qtd: 1",
    "Item: Impressão restaurante",
    "Obs: teste de impressora",
    "================================",
    "\n\n",
  ].join("\n");
}
